import * as React from "react";
import { LinkProps, useHref } from "react-router";
import { Link as WebUiLink } from "@stenajs-webui/elements";
import { useNavigate } from "react-router";

export const Link: React.FC<Omit<LinkProps, "ref">> = ({
  children,
  to,
  onClick,
  ...props
}) => {
  const navigate = useNavigate();
  let href = useHref(to);

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    navigate(to);
  };

  return (
    <WebUiLink
      onClick={handleClick}
      href={href}
      style={{ display: "flex" }}
      {...props}
    >
      {children}
    </WebUiLink>
  );
};
